import SERVICES from 'app-constants/service.names';
import { CollectionService } from './base.service';

class Service extends CollectionService {
  constructor() {
    super(SERVICES.CUSTOMER);
  }
  getPcustomer = (params) => this.client.get(`/pcustomers`, params);
  createPCus = (data) => this.client.post(`/pcustomers`, data);
  updatePCus = (id, data) => this.client.put(`/pcustomers/${id}`, data);
  getUserCus = (id, params?: any) =>
    this.client.get(`/user/cus/${id}`, { params });
}

export default new Service();
